// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__3jB6U","label":"SetPasswdForm_label__1Sy4Z"};